<app-ngrid #docGrid [selectMode]="'none'" [title]="'Pobierz szablon'" [searchable]="true" [exportable]="false"
    [apiMethod]="'documents/application-templates?type=data-change'" [lazy]="false" (onSelect)="onSelect($event)" (onUnselect)="onUnselect()"
    (onButtonClick)="openDoc($event)" [cols]="[
          { field: 'docType', header: '', columnType: 'icon' },
          { field:'docFileName',header:'Nazwa szablonu' },
          { field:'docType',header:'Typ szablonu' },
          { field: 'id', header: 'Pobierz', columnType: 'button' }
          ]">
</app-ngrid>
